import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-business-s',
  templateUrl: './business-s.component.html',
  styleUrls: ['./business-s.component.css']
})
export class BusinessSComponent implements OnInit {
    public itemsListBusinessViews: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadBusinessViews(): Promise<void> {
        this.itemsListBusinessViews = await this.datatask.Post(1142);
    }

    private async init() {
        this.loadBusinessViews();
    }

    ngOnInit() {
        this.init();
    }
}
